import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { ConfirmationService } from 'primeng/api';
import { forkJoin, Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-gdpr',
  templateUrl: './admin-gdpr.component.html'
})
export class AdminGdprComponent implements OnDestroy, OnInit {
  form;
  
  member;
  primaryinstitution;
  result;
  subscriptions: Subscription[] = [];
  imageToShow: any;
  imagewidth;
  imageheight;

  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    public confirmationService: ConfirmationService) { }

    ngOnInit(): void {
      this.form = this.fb.group({
        memberId: ['', Validators.required]
      });
    }

  confirmGDPR(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Är du säker på att du vill avidentifiera aktuell medlem?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         alert('Funktionen inte implementerad');
      },
      reject: () => {
      }
    });
  }

  getMemberInfo() {
    let memberid = this.form.get('memberId').value;
    this.memberService.getMemberById(+memberid).subscribe(response => {
      if (response) {
        this.member = response;
      }
    });
    this.memberService.getMemberPrimaryInstitution(+memberid).subscribe(response => {
      if (response) {
        this.primaryinstitution = response;
      }
    });

    let memberinfo = this.memberService.getMemberById(+memberid);
    let memberprimaryinstitution = this.memberService.getMemberPrimaryInstitution(+memberid);
    this.subscriptions.push(forkJoin([
      memberinfo,
      memberprimaryinstitution
    ]).subscribe(response => {
      this.member = response[0];

      this.primaryinstitution = response[1];
      this.getImageFromService(this.member.id);
    }));

  }

  /* FOTO */
  getImageFromService(memberid) {
    this.memberService.GetMemberImageThumbnail(memberid).subscribe(data => {
      if (data !== null) {
        this.createImageFromBlob(data);
      } else {
        this.imageToShow = null;
      }
    }, error => {
      this.imageToShow = null;
    });
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;

      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width / 2;
      self.imageheight = image.height;
    });
    image.src = imgdata;
  }
  /* FOTO */

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}
